// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"U3aYPZkFC8CCYIeYLcEsz","chipContainer":"_3-CJAO1HpQesM9C-mA7y3f","buttonContainer":"gzZbCw1z0A3f04rCHhG_E"};